import radius from './radii';

const borders: { [key: string]: string } = {
  ...radius,
};

export default borders;
